import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./header";
import { FaArrowLeft, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import Footer from "./Footer";
import { getLoggedUser } from "../controllers/AuthController";
import { useEffect } from "react";
import { Helmet } from "react-helmet";

const API_BASE_URL = `${process.env.REACT_APP_API_URL}`;
const THEME_COLOR = "#0f172a";

const styles = {
  inputWrapper: {
    position: "relative",
    width: "100%",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: "25px",
    marginTop: "10px",
  },
  secTitle: {
    fontSize: "28px",
    fontWeight: "800",
    color: "#0F172A",
    letterSpacing: "-0.5px",
    marginBottom: "4px",
  },
  secDesc: { fontSize: "15px", color: "#64748B", fontWeight: "500" },
  viewAll: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#D60000",
    cursor: "pointer",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },

  eyeIcon: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: "#64748b",
    fontSize: "16px",
  },

  page: {
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
    fontFamily: "'Inter', sans-serif",
  },
  container: {
    maxWidth: "480px",
    margin: "0 auto",
    padding: "100px 20px",
  },
  card: {
    background: "linear-gradient(135deg, #e23552 0%, #0e0f0f 100%)",
    borderRadius: "16px",
    padding: "30px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    border: "1px solid #e2e8f0",
  },
  title: {
    fontSize: "22px",
    fontWeight: 700,
    color: "#e2e8f0",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "10px",
  },
  subtitle: {
    fontSize: "13px",
    color: "#d7e5fa",
    marginBottom: "24px",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    marginBottom: "16px",
  },
  label: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#e2e8f0",
  },
  input: {
    padding: "12px",
    // paddingRight: "40px",   // 👈 IMPORTANT
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    fontSize: "14px",
    outline: "none",
    backgroundColor: "#f8fafc",
    width: "100%",
  },

  btn: {
    width: "100%",
    backgroundColor: THEME_COLOR,
    color: "#fff",
    padding: "14px",
    borderRadius: "10px",
    border: "none",
    fontWeight: 600,
    fontSize: "15px",
    cursor: "pointer",
    marginTop: "10px",
  },
  back: {
    marginTop: "20px",
    fontSize: "13px",
    color: "#e2e8f0",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    justifyContent: "center",
  },
  status: (type) => ({
    marginTop: "16px",
    padding: "12px",
    borderRadius: "8px",
    fontSize: "13px",
    backgroundColor: type === "error" ? "#fee2e2" : "#dcfce7",
    color: type === "error" ? "#b91c1c" : "#166534",
    border: `1px solid ${type === "error" ? "#fca5a5" : "#86efac"}`,
  }),
};

const ChangePasswordPage = () => {
  const [currentView, setCurrentView] = useState("home");

  // Initial cart load
  const [cartCount, setCartCount] = useState(() => {
    const savedCart = JSON.parse(localStorage.getItem("cart")) || [];
    return savedCart.reduce((sum, item) => sum + (item.quantity || 1), 0);
  });

  const [banners, setBanners] = useState([]);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const [activeCategory, setActiveCategory] = useState(
    localStorage.getItem("activeCategory") || "residential",
  );
  const [usingMock, setUsingMock] = useState(false);

  // --- API FETCH ---
  const [allProducts, setAllProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [wishlistIds, setWishlistIds] = useState(new Set());

  const navigate = useNavigate();
  const userIdentifier = getLoggedUser();

  const [show, setShow] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const storedUserData = localStorage.getItem("userData");

    if (!storedUserData) {
      navigate("/"); // ✅ redirect if no user
      return;
    }
  }, [navigate]);

  const handleSubmit = async () => {
    setStatus(null);

    const { email, existingPassword, newPassword, confirmPassword } = form;

    if (!email || !existingPassword || !newPassword || !confirmPassword) {
      return setStatus({ type: "error", message: "All fields are required" });
    }

    if (newPassword !== confirmPassword) {
      return setStatus({ type: "error", message: "Passwords do not match" });
    }

    try {
      setLoading(true);
      const res = await axios.post(`${API_BASE_URL}/change_password`, {
        email,
        existingPassword,
        newPassword,
        confirmPassword,
      });

      if (res.data.status === true || res.data.status === "success") {
        setStatus({
          type: "success",
          message: "Password changed successfully",
        });
        setTimeout(() => navigate("/auth"), 2000);
      } else {
        throw new Error(res.data.message || "Failed to change password");
      }
    } catch (err) {
      setStatus({
        type: "error",
        message: err.response?.data?.message || err.message,
      });
    } finally {
      setLoading(false);
    }
  };
  {
    /* --- CONDITIONAL VIEWS --- */
  }
  return (
    <>
      <Helmet>
        <title>Change Password | CGRMART</title>

        <meta
          name="description"
          content="Securely update your account password at CGRMART. Protect your account with a strong password."
        />

        {/* ❌ IMPORTANT: Do NOT index this page */}
        

        {/* Security related meta */}
        <meta httpEquiv="Cache-Control" content="no-store" />
        <meta httpEquiv="Pragma" content="no-cache" />

        {/* Open Graph (optional) */}
        <meta property="og:title" content="Change Password | CGRMART" />
        <meta
          property="og:description"
          content="Update your password securely."
        />
        <meta property="og:type" content="website" />

        {/* Canonical */}
        <link rel="canonical" href="https://cgrmart.com/changepassword" />
      </Helmet>

      <Header />
      <main style={styles.page}>
        <div style={styles.container} className="change-password-container">
          <style>{`
            @media (max-width: 768px) {
              .change-password-container { max-width: 100% !important; padding: 100px 15px !important; }
              .change-password-card { padding: 25px 20px !important; border-radius: 12px !important; }
              .change-password-title { font-size: 20px !important; }
              .change-password-subtitle { font-size: 12px !important; }
            }
            @media (max-width: 480px) {
              .change-password-container { padding: 100px 10px !important; }
              .change-password-card { padding: 20px 15px !important; }
              .change-password-title { font-size: 18px !important; }
            }
          `}</style>
          <div style={styles.card} className="change-password-card">
            <h1 style={styles.title} className="change-password-title">
              <FaLock /> Change Password
            </h1>
            <p style={styles.subtitle} className="change-password-subtitle">
              For security, choose a strong new password
            </p>

            {/* Email */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>User Email</label>
              <div style={styles.inputWrapper}>
                <input
                  type="email"
                  name="email"
                  placeholder="User Email"
                  style={styles.input}
                  value={form.email}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Existing Password */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>Current Password</label>
              <div style={styles.inputWrapper}>
                <input
                  type={show.current ? "text" : "password"}
                  name="existingPassword"
                  placeholder="Current Password"
                  style={styles.input}
                  value={form.existingPassword}
                  onChange={handleChange}
                />
                <span
                  style={styles.eyeIcon}
                  onClick={() => setShow({ ...show, current: !show.current })}
                >
                  {show.current ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>

            {/* New Password */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>New Password</label>
              <div style={styles.inputWrapper}>
                <input
                  type={show.new ? "text" : "password"}
                  name="newPassword"
                  placeholder="New Password"
                  style={styles.input}
                  value={form.newPassword}
                  onChange={handleChange}
                />
                <span
                  style={styles.eyeIcon}
                  onClick={() => setShow({ ...show, new: !show.new })}
                >
                  {show.new ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>

            {/* Confirm New Password */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>Confirm New Password</label>
              <div style={styles.inputWrapper}>
                <input
                  type={show.confirm ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirm New Password"
                  style={styles.input}
                  value={form.confirmPassword}
                  onChange={handleChange}
                />
                <span
                  style={styles.eyeIcon}
                  onClick={() => setShow({ ...show, confirm: !show.confirm })}
                >
                  {show.confirm ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>

            <button
              style={styles.btn}
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Password"}
            </button>

            {status && (
              <div style={styles.status(status.type)}>{status.message}</div>
            )}

            <div style={styles.back} onClick={() => navigate(-1)}>
              <FaArrowLeft /> Back
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ChangePasswordPage;
